import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2026 Innodata Solutions NZ. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;